module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', {
    staticStyle: {
      "width": "450px"
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Pending Info ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goToPaymentPendingList()
      }
    },
    slot: "extra"
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.isLoading) ? _c('Spin', {
    attrs: {
      "size": "large"
    }
  }) : [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("dateFormatted")(_vm.paymentPending.transactionDate)) + "\n                "), _c('h5', [_vm._v(_vm._s(_vm.paymentPending.bankAccountName))])]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "12",
      "offset": "2"
    }
  }, [(_vm.isSpecialMarking) ? _c('Tag', {
    attrs: {
      "type": "border",
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currencyInter")(_vm.paymentPending.amount)) + "\n                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentPending.currency),
      expression: "paymentPending.currency"
    }]
  }, [_vm._v("(" + _vm._s(_vm._f("currency")(_vm.amountIdr)) + ")")])]) : _c('Tag', {
    attrs: {
      "type": "border",
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.paymentPending.amount)) + " ")])], 1)], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4246d7fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentPendingRowCard.vue
// module id = 1799
// module chunks = 1